/* Shopify's explicit prefix syntax also covers product-title partial words.
   Preserve quoted/advanced searches and user-provided wildcard operators. */
(function () {
  'use strict';
  if (window.__ddPrefixSearchBound) return;
  window.__ddPrefixSearchBound = true;
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[role="search"], .dd-drawer__search')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var query = input.value.trim();
    if (!query || /[*:"()\\]|(?:^|\s)[+-]|\b(?:AND|OR|NOT)\b/.test(query)) return;
    if (/[\p{L}\p{N}][\p{L}\p{N}'’-]+$/u.test(query)) input.value = query + '*';
  }, true);
})();
